export default "assets/example-3.0120bfb60e944487.png"